// Indent a JSON document for reading.
//
// SHARED, BECAUSE IT WAS ABOUT TO BE WRITTEN A SECOND TIME. It started life inside UapiTraceSteps as
// `prettyBody`, for diffing trace bodies that are stored as single-line JSON.stringify output. The
// sync-template task editor needs exactly the same thing for its instruction JSON, and importing a
// trace-rendering component — which drags in DiffModal, the auth context and a stylesheet — to borrow
// five lines would be the wrong dependency entirely.
//
// NOT EVERYTHING HANDED TO THIS IS JSON. An instruction can be plain text, and a trace body can be XML
// or an error string. Anything that does not parse is returned exactly as it came in rather than
// replaced with an error: the reader wants to see what is actually stored, and a formatter that eats
// its input when it cannot improve it is worse than one that does nothing.
export const prettyJson = (text) => {
    if (text === null || text === undefined || text === '') return '';
    try {
        return JSON.stringify(JSON.parse(text), null, 2);
    } catch (e) {
        return String(text);
    }
};

export default prettyJson;
